import { KeyValuePair } from '../../../../documents/document-filter-item';
import { dataMember, required, typedArray } from 'santee-dcts';

export class AdminUsageReportOptionFilterItem {
    @dataMember()
    @required({nullable: true})
    public site: KeyValuePair;
}


export class AdminUsageEQueriesReportOptionFilterItemsReadModel {
    @dataMember()
    @required({nullable: true})
    @typedArray(AdminUsageReportOptionFilterItem)
    public filterItems: AdminUsageReportOptionFilterItem[];
}
